import {
  Box,
  InputLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import { debounce } from "lodash";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const IconTextInput = ({ data, isLeaflet, setIconText }) => {
  const { t } = useTranslation();
  const [showIconText, setShowIconText] = React.useState(
    data?.marker?.iconText?.length > 0
  );
  const [textValue, setTextValue] = React.useState(data?.marker?.iconText);
  const debounceTextIcon = React.useCallback(
    debounce((value) => setIconText(value), 300),
    [setIconText]
  );

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length > 3) return;
    setTextValue(value);
    debounceTextIcon(value);
  };

  useEffect(() => {
    
    setShowIconText(data?.marker?.iconText?.length > 0);
    setTextValue(data?.marker?.iconText);
  }, [data?.id]);

  const handleCheck = (e) => {
    const value = e.target.checked;
    setShowIconText(value);
   if(!value) {
    setIconText(null);
    setTextValue("");
   }
  };

  return (
    <Stack direction="column" spacing={1} my={2}>
      <Stack direction="row" alignItems="center">
        <Switch
        size="small"
          name="iconText"
          checked={showIconText}
          onChange={handleCheck}
        />
        <Typography variant="body1">{t("/editor.gui.iconText.switch")}</Typography>
      </Stack>
      {showIconText ? (
        <Box id="iconText" mb={2}>
          <InputLabel shrink>{t("/editor.gui.iconText.input")}</InputLabel>
          <TextField placeholder="Ex: 123" size="small" value={textValue} onChange={handleChange} />
        </Box>
      ) : null}
    </Stack>
  );
};

export default IconTextInput;
